module.exports = __webpack_public_path__ + "img/map_corner-box.891be8a2.jpg";